import { Checkbox } from "@/shared/components/ui/checkbox";
import {
  useHtzPositionCatalogPutActiveCatalogMutation,
  useHtzPositionCatalogShowActiveCatalogQuery,
} from "@/services/backend/htz/position-catalog/api/position-catalog-api";
import { CheckedState } from "@radix-ui/react-checkbox";
import { useToast } from "@/shared/hooks/use-toast";
import { parseRTKQueryError } from "@/shared/components/errors/parse-r-t-k-query-error";

export interface ActivePositionCatalogCheckboxProps {
  companyId: string;
  catalogId: string;
}

export function ActivePositionCatalogCheckbox({
  companyId,
  catalogId,
}: ActivePositionCatalogCheckboxProps) {
  const { data: activeCatalog } = useHtzPositionCatalogShowActiveCatalogQuery({
    companyId,
  });

  const [put, { isLoading, error, reset }] =
    useHtzPositionCatalogPutActiveCatalogMutation();

  const { toast } = useToast();

  if (error) {
    toast({
      ...parseRTKQueryError(error),
      variant: "destructive",
    });
    reset();
  }

  if (!activeCatalog) {
    return null;
  }

  const checked = activeCatalog.catalogId === catalogId;
  const onCheckedChange = (newState: CheckedState) => {
    if (isLoading) {
      return;
    }

    switch (newState) {
      case true:
        put({
          companyId,
          catalogId,
        });
        break;
      case false:
        put({
          companyId,
          catalogId: null,
        });
        break;
      case "indeterminate":
        break;
      default:
        break;
    }
  };

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={isLoading ? "animate-pulse" : ""}
      disabled={isLoading}
    />
  );
}
